import type { AppState } from 'types/app';
import type { DevicePropsState } from 'store/ducks/deviceProps/types';

// Selectors
export const selectLayoutState = (state: AppState): DevicePropsState => state.deviceProps;
